// used in bundle name
export const deckPorchOrFloorArea = ['EXTERIOR DECK', 'PORCH', 'DECK', 'PORCH MATERIAL', 'FLOOR AREA']
